// Recursive function to flatten an ad unit and its children.
export function flattenAdUnit(unit, parentId = null) {
  // Use ad_unit_id if available; otherwise, use the existing id.
  const unitId = unit.ad_unit_id || unit.id

  // Format the current unit with the computed id and parent id.
  const formattedUnit = {
    ...unit,
    id: unitId,
    parent: parentId
  }

  // Start with the current unit.
  let flatUnits = [formattedUnit]

  // Recursively flatten children if any.
  if (unit.children && unit.children.length > 0) {
    unit.children.forEach(child => {
      flatUnits = flatUnits.concat(flattenAdUnit(child, unitId))
    })
  }

  return flatUnits
}
